import NotificationService from 'src/services/notifications'
import { date } from 'quasar'

export default {
  setUnread (unreadCount) {
    this.total_unread = unreadCount
  },
  addNotification (notification) {
    const unread = {
      read_at: null,
      ...notification
    }
    const notifications = this.notifications
    notifications.unshift(unread)
    if (notifications.length > 10) {
      notifications.pop()
    }

    this.notifications = notifications
    this.setUnread(this.total_unread + 1)
  },
  fetchNoitifications () {
    const promise = NotificationService.fetchPaginated(this.pagination.current_page + 1)

    promise.then(response => {
      this.setUnread(response.total_unread)
      if (response.current_page > 1) this.notifications = this.notifications.concat(response.data)
      else this.notifications = response.data

      const pagination = response
      delete response.data
      this.pagination = pagination
    })

    return promise
  },
  markAllAsRead () {
    const promise = NotificationService.markAllAsRead()

    promise.then(() => {
      const notifications = this.notifications.map(notification => {
        notification.read_at = date.formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
        return notification
      })
  
      this.notifications = notifications
      this.setUnread(0)
    })

    return promise
  },
  markAsRead (notificationId) {
    const promise = NotificationService.markAsRead(notificationId)

    promise.then(() => {
      const notifications = this.notifications.map(notification => {
        if (notification.id === notificationId) {
          notification.read_at = date.formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
        }
        return notification
      })
  
      this.notifications = notifications
      this.setUnread(this.total_unread - 1)
    })

    return promise
  },
  deleteAll () {
    const promise = NotificationService.deleteAll()

    promise.then(() => {
      this.setUnread(0)
      this.notifications = []
      this.pagination = { current_page: 0 }
    })

    return promise
  },
  deleteNotification (notificationId) {
    const promise = NotificationService.deleteNotification(notificationId)

    promise.then(() => {
      if (this.notifications.find(noti => noti.id === notificationId)?.read_at === null) {
        this.setUnread(this.total_unread - 1)
      }
      this.notifications = this.notifications.filter(notif => notif.id !== notificationId)
    })

    return promise
  }
}
